import { bootstrapApplication } from '@angular/platform-browser';

if (typeof window !== 'undefined') {
  const host = window.location.hostname;
  if (host !== 'localhost' && !host.startsWith('dev-')) {
    console.log = () => undefined;
  }
}
import { appConfig } from './app/app.config';
import { App } from './app/app';

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
